export const durationInMiliseconds = 10 * 1000;

export default { durationInMiliseconds };
